import { SESSION_CHANNEL_NAME } from '../constants/session';

export const SESSION_EVENTS = {
  ACTIVITY: 'activity',
  WARNING: 'warning',
  CONTINUE: 'continue',
  LOGOUT: 'logout',
};

let channel = null;

function getChannel() {
  if (typeof BroadcastChannel === 'undefined') return null;
  if (!channel) {
    channel = new BroadcastChannel(SESSION_CHANNEL_NAME);
  }
  return channel;
}

export function broadcastSessionEvent(type, payload = {}) {
  const bc = getChannel();
  if (!bc) return;
  bc.postMessage({ type, payload, ts: Date.now() });
}

export function subscribeSessionEvents(handler) {
  const bc = getChannel();
  if (!bc) return () => {};

  const listener = (event) => {
    if (event?.data?.type) {
      handler(event.data);
    }
  };

  bc.addEventListener('message', listener);
  return () => bc.removeEventListener('message', listener);
}

export function closeSessionChannel() {
  if (channel) {
    channel.close();
    channel = null;
  }
}
